export function getIdFromIri(iri: string) {
    return iri.split('/')[iri.split('/').length - 1];
}

export function pad(time: string, n: number) {
    if (time.toString().length < n) {
        return '0' + time;
    }

    return time;
}
